// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  qualityAssure: false,
  // HOST_URL: "http://localhost:3001",
  // NEST_API: "http://localhost:4000",
  // API_BASE_URL: "/vdc/api/v1",
  // GRAPHQL_URI: "http://localhost:4000/graphql",
  // GRAPH_ENDPOINT: "http://localhost:4000/graphql",
  // REST_ENDPOINT_BASE: "http://localhost:4000",
  // WS_ENDPOINT: "http://localhost:4000",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
